// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q_Kt","rootNoMargin":"styles_rootNoMargin__1tYG0"};